module.exports = __webpack_public_path__ + "img/cb.4ff9509.svg";